import { Loading } from "../Loading/Loading";

type Props = {
  variant: "primary" | "outline" | "link";
  loading?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;
export function Button({ variant, className, loading, ...props }: Props) {
  return (
    <button
      className={`transition duration-75 rounded-md text-sm text-text-secondary font-medium leading-normal py-5 px-5 flex gap-1.5 items-center justify-center
      ${variant === "outline" ? "border border-primary !text-primary hover:opacity-80" : ""}
      ${variant === "primary" ? "bg-primary3 hover:opacity-80" : ""}
      ${variant === "link" ? "!p-0" : ""}
      ${
        loading
          ? "opacity-50 cursor-not-allowed"
          : "hover:bg-opacity-20"
      }
      ${
        props.disabled && !loading ? "!bg-[#D2D2D2] cursor-not-allowed !text-black !opacity-100" : ""
      }
      ${className || ""}
    `}
      {...props}
    >
      {props.children}
      {loading && <Loading />}
    </button>
  );
}
